<template>
  <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="pageInfo.pageSizes"
      :page-size="pageInfo.pagesize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
  </el-pagination>
</template>

<script>
export default {
  name: "userPagination",
  props: ['pageInfo'],
  data() {
    return {
    }
  },
  created() {
  },
  watch: {
    pageInfo: function (newVal, oldVal) {
      // console.log(newVal, oldVal)
    }
  },
  methods: {
    handleSizeChange(val) {
      let obj = Object.assign(this.pageInfo, {});
      obj.pagesize = val;
      this.$emit('toPage', obj)
    },
    handleCurrentChange(val) {
      let obj = Object.assign(this.pageInfo, {});
      obj.page = val;
      this.$emit('toPage', obj)
    }
  },
}
</script>

<style scoped>
  .el-pagination {
    text-align: center;
  }

  /deep/ .el-input__inner {
    /*min-width: 100px;*/
    -webkit-appearance: none;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 28px;
    outline: 0;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  }
</style>
